import { Component, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'modal-home-sreen-safari',
  templateUrl: 'modal-home-sreen-safari.html'
})
export class ModalHomeSreenSafariComponent {

  @Input() configColor: any;
  @Input() localstorageName: string = 'viewOnBoarding';
  @ViewChild('modalContainer') modalContainer: ElementRef;

  public showModal: boolean = false;

  constructor(
  ) { }

  ngOnInit(): void {
    let valueView = window.localStorage.getItem(this.localstorageName);
    if (valueView !== "true") {
      this.showModal = true;
      setTimeout(() => {
       // this.animatorModal = this.animationService.builder();
        // this.animatorModal.setType('fadeIn').show(this.modalContainer.nativeElement);
      }, 800);
    }
  }

  closeModal() {
    window.localStorage.setItem(this.localstorageName, "true");
    setTimeout(() => {
      this.showModal = false;
    }, 600);
  }
}



// WEBPACK FOOTER //
// ./src/components/modal-home-sreen-safari/modal-home-sreen-safari.ts